<template>
  <el-dialog
    title="调整详情"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="700px"
    @close="handleClose">

    <div v-loading="loading" style="max-height: 500px;overflow-y: auto;">
      <!-- 基本信息 -->
      <el-descriptions :column="2" border size="small" style="margin-bottom: 20px;">
        <el-descriptions-item label="客户名称">{{ detailData.contract_info ? detailData.contract_info.party_a : '' }}</el-descriptions-item>
        <el-descriptions-item label="项目名称">{{ detailData.project_info ? detailData.project_info.name : '' }}</el-descriptions-item>
        <el-descriptions-item label="业务类型">{{ detailData.contract_info ? detailData.contract_info.entry_type_name : '' }}</el-descriptions-item>
        <el-descriptions-item label="应收月份">{{ detailData.finance_info ? detailData.finance_info.month : '' }}</el-descriptions-item>
        <el-descriptions-item label="合同金额">{{ detailData.finance_info ? detailData.finance_info.amount : '' }}</el-descriptions-item>
        <el-descriptions-item label="应收金额">{{ detailData.finance_info ? detailData.finance_info.invoice_amount : '' }}</el-descriptions-item>
      </el-descriptions>

      <!-- 调整记录 -->
      <div v-if="detailData.id">
        <div style="margin-bottom: 10px; font-weight: bold; color: #409EFF;">调整记录</div>
        <el-table :data="[detailData]" border size="mini" max-height="300">
          <el-table-column prop="symbol_name" label="变动原因" align="center" width="150"></el-table-column>
          <el-table-column prop="symbol_value" label="符号" align="center" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.symbol_value=='+'" style="color: #28af05">+</span>
              <span v-else-if="scope.row.symbol_value=='-'" style="color: #ff3d00">-</span>
              <span v-else>{{ scope.row.symbol_value }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="变动金额" align="center" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.symbol_value=='+'" style="color: #28af05">{{ scope.row.amount }}</span>
              <span v-else-if="scope.row.symbol_value=='-'" style="color: #ff3d00">{{ scope.row.amount }}</span>
              <span v-else>{{ scope.row.amount }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="create_time_date" label="创建时间" align="center" width="160"></el-table-column>
          <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
      <el-empty v-else description="暂无调整记录" :image-size="80"></el-empty>

      <!-- 流程信息 -->
      <div v-if="detailData.task_id" style="margin-top: 20px;">
        <div style="margin-bottom: 10px; font-weight: bold; color: #409EFF;">流程信息</div>
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="流程ID">{{ detailData.task_id }}</el-descriptions-item>
          <el-descriptions-item label="流程状态">
            <el-tag size="mini" :type="detailData.task_status > 0 ? 'success' : 'info'">
              {{ detailData.task_status > 0 ? '已完成' : '进行中' }}
            </el-tag>
          </el-descriptions-item>
        </el-descriptions>
        <el-button size="mini" type="primary" style="margin-top: 10px;" @click="showTask(detailData.task_id)">查看流程</el-button>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import CommonHelp from "../common/CommonHelp";

export default {
  name: "AdjustmentDetailDialog",
  data() {
    return {
      dialogVisible: false,
      loading: false,
      finance_id: '',
      detailData: {}
    }
  },
  methods: {
    // 打开弹框
    open(finance_id) {
      this.finance_id = finance_id;
      this.dialogVisible = true;
      this.getDetail();
    },

    // 获取详情数据
    getDetail() {
      var that = this;
      that.loading = true;

      // 调用接口获取调整详情
      CommonHelp.get("FinanceChange/changeDetail?finance_id=" + this.finance_id, {}, res => {
        if (res.code) {
          that.detailData = res.data || {};
        } else {
          that.$message.error(res.msg || '获取详情失败');
        }
        that.loading = false;
      });
    },

    // 下载文件
    downloadFile(file) {
      if (file.file_path) {
        window.open(CommonHelp.getBaseURL() + file.file_path);
      }
    },

    // 关闭弹框
    handleClose() {
      this.finance_id = '';
      this.detailData = {};
    },
    // 查看流程
    showTask(taskId) {
      let url = '/#/flow/FlowView?task_id=' + taskId;
      window.open(url, '_blank');
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-descriptions__label {
  font-weight: bold;
  background-color: #fafafa;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/components/AdjustmentDetailDialog.vue